/**
 * The five inbox filter states: an all-state plus the four categories.
 * Reports the chosen category up to the screen, which owns the URL.
 */
import { Button } from "@sportsmet/ui";
import type { ReactNode } from "react";

export type typeInboxCategory = "invite" | "pools" | "games" | "chat";

export const INBOX_FILTERS = [
  { value: null, label: "All" },
  { value: "invite", label: "Invite" },
  { value: "pools", label: "Pools" },
  { value: "games", label: "Games" },
  { value: "chat", label: "Chat" },
] as const;

export type typeNotificationFilterChipsProps = {
  activeCategory: typeInboxCategory | null;
  onSelect: (payload: { category: typeInboxCategory | null }) => void;
};

export const NotificationFilterChips = ({
  activeCategory,
  onSelect,
}: typeNotificationFilterChipsProps): ReactNode => (
  <div
    role="group"
    aria-label="Filter notifications"
    className="flex flex-wrap gap-2"
  >
    {INBOX_FILTERS.map((filter) => {
      const isActive = filter.value === activeCategory;
      return (
        <Button
          key={filter.label}
          type="button"
          size="sm"
          className="rounded-full"
          variant={isActive ? "primary" : "secondary"}
          aria-pressed={isActive}
          onClick={() => {
            onSelect({ category: filter.value });
          }}
        >
          {filter.label}
        </Button>
      );
    })}
  </div>
);
